import React, { Component } from 'react';
import ForScreen from '../Containers/ForScreen';
import './ChildInfo.scss';

class ChildInfo extends Component {
  state = {
    shortViewMode: false
  };

  componentWillMount() {
    if (this.props.shortViewMode) {
      this.setState({ shortViewMode: this.props.shortViewMode });
    }
  }

  calculateAge(birthday) {
    let birthdayDate = new Date(birthday);
    const ageDifMs = Date.now() - birthdayDate.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  render() {
    if (!this.props.child) return null;

    const shortViewMode = this.state.shortViewMode;

    let avatarClasses = 'media-object img-circle';
    if (shortViewMode) avatarClasses += ' mobile';

    return (
      <div className="child-info">
        <img
          className={avatarClasses}
          alt="child avatar"
          src={this.props.child.avatarUrl + '/80'}
        />

        {shortViewMode ? (
          <React.Fragment>
            <ForScreen desktop>
              <h4 className="child-name">
                Gewünscht von <br />{' '}
                <strong>{this.props.child.listname}</strong>
              </h4>
            </ForScreen>
            <ForScreen mobile>
              <h4 className="child-name">
                <strong>{this.props.child.listname}</strong>
              </h4>
            </ForScreen>
            <div className="hidden-xs">
              <p className="wish-info">{this.props.child.age} Jahre alt</p>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <h4 className="child-name">
              Gewünscht von <br /> <strong>{this.props.child.listname}</strong>
            </h4>
            <p className="wish-info">{this.props.child.age} Jahre alt</p>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default ChildInfo;



// WEBPACK FOOTER //
// ./src/Component/ChildInfo.js